// extracted by css-extract-rspack-plugin
export default {"NewViewGraphicContainer":"NewViewGraphic-module__NewViewGraphicContainer__IsTGH"};